<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-amount
      class="margin__t--6"
      v-model="model"
      :v="validator"
      :id="id"
      :placeholder="translate(placeholder)"
    />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject, watch } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedure, useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'
import { useMoney } from '@/composables/app/useMoney'

const InputAmount = defineAsyncComponent(() => import('&/atoms/InputAmount'))

const { block } = defineProps({
  block: { type: Object, required: true }
})

const procedure = inject('procedure')
const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { getAmount } = useMoney()
const { getFromProcedure } = useProcedure({ procedure })
const { label, placeholder, model, id, defaultValue } = useModule({ component: block, parent: procedure_execution, default_value: getFromProcedure({ key: block.default_value }) })
const { validator } = useProcedureBlockValidator({ validations: block.mandatory, state: model })

const defaultAmount = computed(() => getAmount({ amount: defaultValue.value }))

if (!model.value && defaultAmount.value) model.value = defaultAmount.value

watch(defaultAmount, (to, from) => {
  if (model.value === from) model.value = to
})
</script>
